"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTagConstants = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var BcTagConstants = (function () {
    function BcTagConstants() {
    }
    BcTagConstants.BC_ACTIVE = 'active';
    BcTagConstants.BC_ICON_REMOVE_ITEM = 'error';
    BcTagConstants.BC_ICON_ADD_FILTER = 'plus';
    BcTagConstants.BC_ATTRIBUTE_ADD_ICON = 'iconadd';
    BcTagConstants.BC_ATTRIBUTE_DELETE_ICON = 'icondelete';
    BcTagConstants.BC_CLASS_NAME_ICON = 'bc-icon';
    BcTagConstants.BC_ATTRIBUTE_WIDTH_TAG = 'widthTag';
    BcTagConstants.BC_SELECTION_TAG = 'selectionTag';
    BcTagConstants.BC_EXPANDED_ARIA_LABEL = 'expandido';
    BcTagConstants.BC_CONTRACTED_ARIA_LABEL = 'contraido';
    BcTagConstants.BC_ICON_REMOVE_ARIA_LABEL = 'Quitar';
    BcTagConstants.BC_FLOAT_MENU = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-float-menu");
    BcTagConstants.BC_CLASS_NAME_COMPONENT = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-tag");
    BcTagConstants.BC_CLASS_NAME_CONTENT = "".concat(BcTagConstants.BC_CLASS_NAME_COMPONENT, "-content");
    BcTagConstants.BC_ICON_TAG_TOGGLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-icon-tag-toggle");
    BcTagConstants.BC_CONTAINER_CHECKBOX = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-container-checkbox");
    BcTagConstants.BC_CLASS_MENU_FLOAT_OPTION = "".concat(BcTagConstants.BC_FLOAT_MENU, "-option");
    BcTagConstants.BC_CLASS_MENU_FLOAT_TEXT = "".concat(BcTagConstants.BC_FLOAT_MENU, "-main-text");
    BcTagConstants.BC_CLASS_MENU_FLOAT_TOGGLE = "".concat(BcTagConstants.BC_FLOAT_MENU, "-toggle");
    BcTagConstants.BC_CLASS_MENU_FLOAT_CONTENT_ACTIVE = "".concat(BcTagConstants.BC_FLOAT_MENU, "-content-active");
    BcTagConstants.BC_CLASS_NAME_FILTER_ACTIVE = "".concat(BcTagConstants.BC_CLASS_NAME_COMPONENT, "-filter-").concat(BcTagConstants.BC_ACTIVE);
    BcTagConstants.BC_CLASS_NAME_FILTER = "".concat(BcTagConstants.BC_CLASS_NAME_COMPONENT, "-filter");
    BcTagConstants.BC_CLASS_NAME_FILTER_DISABLED = "".concat(BcTagConstants.BC_CLASS_NAME_COMPONENT, "-filter-disabled");
    BcTagConstants.BC_CLASS_NAME_DROPDOWN = "".concat(BcTagConstants.BC_CLASS_NAME_COMPONENT, "-dropdown");
    BcTagConstants.BC_DISPLAY_NONE = 'bc-d-none';
    return BcTagConstants;
}());
exports.BcTagConstants = BcTagConstants;
